import { useState } from 'react';

import { TicketingProvider } from '@neo.tax/shared/graphql';
import { useCurrentCompanyId, useMergeDevTicketing } from '@neo.tax/shared/hooks';

import { ConnectProvider } from './ConnectProvider';
import { ConnectProviderStatus } from './enums';

interface ConnectTicketingProps {
  providerName: TicketingProvider;
  close: () => void;
  restart: () => void;
}

export const ConnectTicketing = ({ close, providerName, restart }: ConnectTicketingProps): React.ReactElement => {
  const companyId = useCurrentCompanyId();

  const [connectStatus, setConnectStatus] = useState<ConnectProviderStatus>(ConnectProviderStatus.NOT_STARTED);

  const { onOpen } = useMergeDevTicketing({
    provider: providerName,
    isParentReady: connectStatus === ConnectProviderStatus.WAITING_TOKEN,
    companyId,
    onSuccess: () => setConnectStatus(ConnectProviderStatus.SUCCESS),
    onError: () => setConnectStatus(ConnectProviderStatus.ERROR),
  });

  const connect = (): void => {
    setConnectStatus(ConnectProviderStatus.WAITING_TOKEN);
    onOpen();
  };

  return (
    <ConnectProvider
      connect={connect}
      close={close}
      restart={restart}
      connectStatus={connectStatus}
      provider={{ providerName, providerType: 'ticketing' }}
    />
  );
};
